import { Component, OnInit, Input, OnChanges } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';
import { Observable, Subject } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-history',
  templateUrl: './history.component.html',
  styleUrls: ['./history.component.css', './../../base/base-table/base-table.component.css']
})
export class HistoryComponent implements OnInit, OnChanges {
  history: Observable<any[]>;
  historyType: string = "All";
  @Input() playerId;

  constructor(private firestore: AngularFirestore, private route: ActivatedRoute) {
  }

  ngOnInit() {
    this.getData();
  }

  ngOnChanges() {
    this.getData();
  }

  getData() {
    if(this.historyType == "All") {
      this.history = this.firestore.collection('history', ref => ref.where('ID', '==', this.playerId).orderBy('Season', 'asc')).valueChanges();
    }
    else {
      this.history = this.firestore.collection('history', ref => ref.where('ID', '==', this.playerId).where('TxType', '==', this.historyType).orderBy('Season', 'asc')).valueChanges();
    }
  }

  updateHistory(event) {
    this.historyType = event.target.value;
    this.getData();
  }
}
